import CollegeSelector from './src/main';

/* istanbul ignore next */
CollegeSelector.install = function(Vue) {
  Vue.component(CollegeSelector.name, CollegeSelector);
};

export default CollegeSelector;
